import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./IssuerPublish.css";
import TopTitleBar from "./TopTitleBar";
import { Link } from "react-router-dom";
import Pagination from "./Pagination";
import Loader from "../../../components/Loader";

import API from "../../../ApiConfig";
import cogoToast from "cogo-toast-react-17-fix";
import { GET_DOCUMENT_DRAFT_BY_ID, DOCUMENT_PREVIEW, BASE_URL, PUBLISH_DOCUMENT_BY_UUID, USER_TOKEN, PUBLISH_VERIFIER_REQUEST_DOCUMENT, PUBLISH_ALL } from "../../../Utils/constant"
import { AuthConsole, Delay, _ToNormal } from "../../../Utils/helper";
import useRefreshToken from "../../../Hooks/usegenerateToken";
import { Icon } from 'react-icons-kit';
import { arrow_right } from 'react-icons-kit/ikons/arrow_right';
import SlideUpWrapper from "../../../components/Transitions/SlideUpWrapper";
import ShimmerLoader from "../../../components/ShimmerLoader";
import BtnLoader from "../../../components/BtnLoader";
import IssuerNavigator from "../../../components/DashBoard/IssuerNavigator";
import Breadcrumb from "../../../components/Verifier/breadcrumb/BreadCrumb";
import PreviewPDF from "../../../components/pdfPreview/Previewpdf";
import { useSelector } from "react-redux";

const IssuerPublish = ({ doc, handleStep }) => {
  let access_token = useRefreshToken(BASE_URL + USER_TOKEN)
  const [currentIndex, setCurrentIndex] = useState(1);
  const [recordsPerPage] = useState(1);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [publishing, setPublishing] = useState(false)
  const [pdfLoading, setPdfLoading] = useState(true)
  const [preview, setPreview] = useState(null);
  const [pdfList, setPdfList] = useState([])
  const User=useSelector(state=>state.User)
  const holder_data=JSON.parse(localStorage.getItem("holder_data"))
  const verifier_request_id=holder_data?.verifier_request_id
  const docID=localStorage.getItem("docID")
  const [totalItems, setTotalItems]=useState("")
  useEffect(() => {
    if (doc.issuer_id)
      getDraftList()
  }, [])

  async function getDraftList() {
    setLoading(true);
    await Delay()
    API.get(GET_DOCUMENT_DRAFT_BY_ID + doc.issuer_id + '/' + doc.id,{
      params:{
        issued_doc_id:docID,
        status:"DRAFT"
      }
    })
      .then(res => {
        if (res.data.status === 200) {
          let data = res.data.data.items
          let result = data.filter(item => item.details.issued_data_state === 'DRAFT')
          setTotalItems(res.data.data.total_items)
          setPdfList(result)
          getPdf(result[0]);
          setLoading(false)
        }
      })
      .catch(err => {
        setLoading(false)
      })
  }

  const getPdf = (item) => {
    if (pdfList) {
      setPdfLoading(true)
      API.get(DOCUMENT_PREVIEW + item.details.issued_uuid)
        .then(response => {
          setPdfLoading(false);
          setPreview(response.data.data.pdf);
        }).catch(err => {
          setPdfLoading(false)
          setPreview(null)
          cogoToast.error(err.message);
        })
    };
  }

  const setCurrentPDF = (index) => {
    if (currentIndex === index)
      return
    getPdf(pdfList[index - 1]);
    setCurrentIndex(index);
  }
  const publishAll = async () => {
    let params = []
    pdfList.forEach(item => {
      params.push(item.details.issued_uuid)
    })
    setPublishing(true)
    await Delay()
    let publish_all_url=`${PUBLISH_ALL}${doc.issuer_id}/${doc.id}`
    let single_publish_url=PUBLISH_DOCUMENT_BY_UUID
    const payload = docID ? [docID] : null
    API.post(docID?single_publish_url:publish_all_url, payload)
      .then(res => {
        let navigateto=User.user_type=="Super Admin"?"/company/2/2/credentials":"/dashboard/Credentials"
        if (res.data.status === 200) {
          cogoToast.success(res.data.message)
          setTimeout(() => navigate(navigateto), 2000)
          // navigate("/dashboard/Credentials")
        }
      })
      .catch(err => {
        AuthConsole(err)
        setPublishing(false)

      })
  }
  const publishHolderData=()=>{
    let params=[]
    pdfList.forEach(item => {
      params.push(item.details.issued_uuid)
    })
    setPublishing(true)
    API.post(PUBLISH_VERIFIER_REQUEST_DOCUMENT + "?issued_document_id="+ params[0] +"&verifier_request_id="+ verifier_request_id)
    .then(res=>{
      if(res.data.status==200){
      AuthConsole(res);

      cogoToast.success(res.data.message)
      localStorage.removeItem("holder_data")

      setTimeout(() => navigate("/dashboard/Credentials"), 2000)
      }
      
    })
    .catch(err=>{
      AuthConsole(err);
      setPublishing(false)
      
    })
  }
  const handlePdfSubmit = () => {
    if (pdfList){
      // if(verifier_request_id){
      //   publishHolderData()
      // }
      // else{
      publishAll()
      // }
    }
  }
  let pdfListCount = pdfList.length;
  const indexOfLastRecord = currentIndex * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const nPages = Math.ceil(pdfListCount / recordsPerPage);
  const currentPDFs = pdfList.slice(indexOfFirstRecord, indexOfLastRecord);
  return (
    <div style={{width:"100%"}}>
      <Breadcrumb pos={4} title="Issue Document" category="issuer" />
      <SlideUpWrapper>
        {/* <TopTitleBar isChild >
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100vw' }}>

            <h2 className="topTitleBarText">
              <Link className="text-decoration-none" to="/dashboard/credentials">
                Documents
              </Link>
              <span className="text-decoration-none" onClick={e => handleStep(2)}> <Icon icon={arrow_right} /> Issue Documents</span>
              <span className="secondaryButton"> <Icon icon={arrow_right} /> {`Document: ${pdfList.length > 0 ? _ToNormal(pdfList[0]?.details.document_name) : ''}`}</span>
            </h2>
            
          </div>
        </TopTitleBar> */}
        <IssuerNavigator
          title="Preview"
          handlestep={handleStep}
          step={4}
          actions={() => pdfLoading?null:<button disabled={publishing} onClick={e => handlePdfSubmit()} className='btn btn-primary' style={{ width: "15%", fontSize: "15px" }}>{publishing ? <BtnLoader label="Issuing Document" /> : totalItems<=1?'Publish':"Publish All"} </button>}
        />
        <section className="frame-wrapper">
          <div className="frame-group">
            <div className="frame-parent1">
              <div className="card-info">
                <div className="card-info-inner">
                  <div className="frame-parent3">
                    <div className="frame-wrapper2">
                      <div className="details-parent">
                        <div className="details">Details</div>
                      </div>
                      <Pagination
                        nPages={nPages}
                        currentPage={currentIndex}
                        setCurrentPage={setCurrentPDF}
                        loading={loading}
                        onPageChange={setCurrentPDF}
                      />
                    </div>
                    <div className="main-content">
                      <div className="subheader">
                        <div className="page-navigation">
                          {loading ? <ShimmerLoader height='6rem' /> :
                            <div className="docs-section">
                              <div className="card-details">
                                <div className="breadcrumb-trail">Design</div>
                                <div className="text95">Total Recipients</div>
                                <div className="text95">Date of Issue</div>
                              </div>
                              <div className="card-details1">
                                <div className="text96">{pdfListCount > 0 ? _ToNormal(pdfList[0]?.details.document_name) : "N/A"}</div>
                                <div className="text97">{pdfListCount > 0 ? pdfListCount : "N/A"}</div>
                                <div className="pagination-items">{pdfList.length > 0 ? pdfList[currentIndex - 1].details.updated_at.split('T')[0] : "N/A"}</div>
                              </div>
                            </div>}
                        </div>
                      </div>
                      <div className="blankDiv"></div>
                      <div className="group-frame">
                        {pdfLoading ? <ShimmerLoader height="32rem" /> : <>
                          {currentPDFs && currentPDFs.length > 0 && currentPDFs.map((pdfItem) => (
                            <embed
                              key={pdfItem.id}
                              id="pdf-viewer"
                              src={preview ? preview + "#toolbar=0" : ""}
                              type="application/pdf"
                            ></embed>
                            // <PreviewPDF doc_id={pdfItem.id} load={loading} setLoading={setLoading} type={'pdf'} />
                          ))}
                        </>}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <button
                className="btn btn-primary"
                onClick={() => { }}
              >
                <div className="next-button">Publish & Email</div>
              </button> */}
              </div>
            </div>
          </div>
        </section>
      </SlideUpWrapper>
    </div>
  );
};

export default IssuerPublish;
